<template>
  <div>
    <b><span>Resumo:</span></b>
    <br>
    <div>
      <div>
        <span><strong>Decisão:</strong> {{ obterDecisao() }} <br></span>
        <span v-show="obterDetalhesDecisao()"><strong>Detalhes da Decisão:</strong> {{ obterDetalhesDecisao() }} <br></span>
      </div>
      <br>
      <div>
        <span v-show="ExisteAnalise(resumo.situacaoDataBusca)">           <strong>Análise cadastral detalhada:</strong> {{ ObterDescricao(resumo.situacaoDataBusca) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoDataBusca)">           <strong>Comparativo de dados:</strong> {{ ObterDescricaoComparativo(comparativo) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoObitoFiscal)">         <strong>Óbito e fiscal:</strong> {{ ObterDescricao(resumo.situacaoObitoFiscal) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoCadastroRestritivo)">  <strong>Cadastro restritivo:</strong> {{ ObterDescricao(resumo.situacaoCadastroRestritivo) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoMidiaDesabonadora)">   <strong>Mídia desabonadora:</strong> {{ ObterDescricao(resumo.situacaoMidiaDesabonadora) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoEmailAge)">            <strong>E-mail age:</strong> {{ ObterDescricao(resumo.situacaoEmailAge) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoCriminalResumo)">      <strong>Análise restritiva:</strong> {{ ObterDescricao(resumo.situacaoCriminalResumo) }} <br></span>    
        <span v-show="ExisteAnalise(resumo.situacaoCriminalDetalhe)">     <strong>Criminal detalhe:</strong> {{ ObterDescricao(resumo.situacaoCriminalDetalhe) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoQuodRufra)">           <strong>Indício de fraude:</strong> {{ ObterDescricao(resumo.situacaoQuodRufra) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoSerproReceita)">       <strong>Análise cadastral simplificada:</strong> {{ ObterDescricao(resumo.situacaoSerproReceita) }} <br></span>
        <span v-show="ExisteAnalise(resumo.situacaoDictMed)">             <strong>AntiFraude:</strong> {{ ObterDescricao(resumo.situacaoDictMed) }} <br></span>
        <span v-show="ExisteAnalise(situacaoDocumentoscopia)">             <strong>Validação documento:</strong> {{ ObterDescricaoDocumentoscopia(situacaoDocumentoscopia) }} <br></span>
      </div>
    </div>
  </div>
</template>

<script>
const SituacaoBmpOrigem = {
  Pendente: 1,
  Aprovado: 2,
  PendenteMesa: 3,
  Negado: 4,
  AguardandoBureau: 5
}

const RESTRICAO_BUREAU = 3
const COMPARATIVO_NAO_CONFORME = 2
const CAMPOS_SITUACAO_BUREAU = [
  'situacaoDataBusca',
  'situacaoObitoFiscal',
  'situacaoCadastroRestritivo',
  'situacaoMidiaDesabonadora',
  'situacaoEmailAge',
  'situacaoCriminalResumo',
  'situacaoCriminalDetalhe',
  'situacaoQuodRufra',
  'situacaoSerproReceita',
  'situacaoDictMed'
]

export default {
  props: {
    onboarding: Object,
    comparativoDados: Array,
    situacaoDocumentoscopia: String,
    situacaoBmpOrigem: Number
  },
  data() {
    return {
      resumo: {},
      comparativo: {},
      bureausConsultados: 0
    }
  },
  methods: {
    alimentarObjeto() {
      let th = this
      Object.assign(th.resumo, th.onboarding)
      Object.assign(th.comparativo, th.comparativoDados)
      th.refresh();
    },
    comparativoIncompativel() {
      return Array.isArray(this.comparativoDados) && this.comparativoDados.some(item => item.comparativoBureau === COMPARATIVO_NAO_CONFORME)
    },
    possuiReprovacaoBureaus() {
      const th = this
      return CAMPOS_SITUACAO_BUREAU.some(campo => th.onboarding && th.onboarding[campo] === RESTRICAO_BUREAU)
    },
    possuiReprovacao() {
      return this.possuiReprovacaoBureaus() || this.comparativoIncompativel()
    },
    obterDecisao() {
      const th = this
      const situacao = th.situacaoBmpOrigem

      if (situacao === null || situacao === undefined)
        return th.possuiReprovacao() ? 'Reprovado' : 'Aprovado'

      if (situacao === SituacaoBmpOrigem.Aprovado)
        return 'Aprovado'

      if (situacao === SituacaoBmpOrigem.Negado || th.possuiReprovacao())
        return 'Reprovado'

      if (situacao === SituacaoBmpOrigem.Pendente)
        return th.possuiReprovacao() ? 'Reprovado' : 'Pendente'

      switch (situacao) {
        case SituacaoBmpOrigem.PendenteMesa:
          return 'Pendente de Mesa'
        case SituacaoBmpOrigem.AguardandoBureau:
          return 'Pendente'
        default:
          return 'Pendente'
      }
    },
    obterDetalhesDecisao() {
      const th = this
      const decisao = th.obterDecisao()

      if (decisao === 'Reprovado')
        return th.comparativoIncompativel()
          ? 'Os dados fornecidos são incompatíveis com os bureaus. Veja a aba "Comparativo de Dados" e realize novo cadastro com dados corrigidos.'
          : 'Reprovado por Políticas Internas. Esta informação é confidencial e não pode ser compartilhada.'

      if (decisao === 'Pendente de Mesa')
        return 'Em análise manual pelo time da BMP. Em breve o status será atualizado.'

      return ''
    },
    ObterDescricao(valor){
      let th = this
      if(valor) 
        return th.$api.Arrays.DescricaoValidacaoOnboardingDetalhe.find((arr) => arr.value == valor).text
      
      return "Validação não encontrada."  
    },
    ObterDescricaoComparativo(){
      let th = this
      if (Array.isArray(th.comparativoDados)) {
        const possuiRestricao = th.comparativoDados.some(item => item.comparativoBureau === 2);
        return possuiRestricao ? th.$api.Arrays.DescricaoValidacaoOnboardingDetalhe.find((arr) => arr.value == 3).text : th.$api.Arrays.DescricaoValidacaoOnboardingDetalhe.find((arr) => arr.value == 2).text;
      }
      
      return th.$api.Arrays.DescricaoValidacaoOnboardingDetalhe.find((arr) => arr.value == 99).text;
    },
    ObterDescricaoDocumentoscopia() {
      let th = this
      
      if (th.situacaoDocumentoscopia && th.situacaoDocumentoscopia.toUpperCase() == "POSITIVE")
        return th.$api.Arrays.DescricaoValidacaoOnboardingDetalhe.find((arr) => arr.value == 2).text

      if (th.situacaoDocumentoscopia && th.situacaoDocumentoscopia.toUpperCase() == "AGUARDANDO RETORNO WEBHOOK.")
        return 'Aguardando retorno do fornecedor.'

      return th.$api.Arrays.DescricaoValidacaoOnboardingDetalhe.find((arr) => arr.value == 3).text
    },
    ExisteAnalise(valor){
      if(valor) 
        return true 
    },
    refresh(){
      this.$forceUpdate();  
    }
  },
}
</script>
<style scoped>
</style>
